import { fmt } from '../lib/format';
import { useBlockNumber } from '../hooks/useBlockNumber';

/** Plain bold-rendered block number for inline use inside footers / meta. */
export default function LiveBlockText() {
  const { data: block } = useBlockNumber();
  return <b>{block ? fmt.blockNumber(block) : '—'}</b>;
}
